module.exports = __webpack_public_path__ + "img/grip2.698943aa.png";